import React from 'react'
import styles from './JobChangeInterestModal.module.css'
import { useStepContext } from '@/components/Context/StepContext'
import { useAbTestGtm } from '@/components/utils/abTest'
import { JobChangeInterestGTMTags } from './types'

type JobChangeInterestModalProps = {
    gtmTags: JobChangeInterestGTMTags
    onComplete: () => void
}

export const JobChangeInterestModal = ({ gtmTags, onComplete }: JobChangeInterestModalProps) => {
    const { updateFormData } = useStepContext()
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    const handleSelect = (value: 'high' | 'moderate') => {
        updateFormData('jobChangeInterest', value)
        onComplete()
    }

    return (
        <div className={styles.overlay} onClick={onComplete} data-click-label={dataClickLabel(gtmTags.dataClickLabels.blank)} data-view-label={dataViewLabel(gtmTags.dataViewLabel)}>
            <div className={styles.modalWrapper} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeButton} onClick={onComplete} type="button" aria-label="閉じる" data-click-label={dataClickLabel(gtmTags.dataClickLabels.close)} />
                <div className={styles.modal}>
                    <div className={styles.title}>
                        <h2 className={styles.titleText}>
                            ＼ 今はどちらに近いですか？ ／
                        </h2>
                    </div>
                    <div className={styles.selectionWrapper}>
                        <button
                            className={styles.button}
                            type={'button'}
                            onClick={() => handleSelect('high')}
                            data-click-label={dataClickLabel(gtmTags.dataClickLabels.high)}
                        >
                            <img src="/entry_form_slide_app/common/jobChangeInterest_high.png" alt="近いうちに転職したい" />
                        </button>
                        <button
                            className={styles.button}
                            type={'button'}
                            onClick={() => handleSelect('moderate')}
                            data-click-label={dataClickLabel(gtmTags.dataClickLabels.moderate)}
                        >
                            <img src="/entry_form_slide_app/common/jobChangeInterest_moderate.png" alt="まずは情報収集したい" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
